module.exports = __webpack_public_path__ + "img/image_6.a4c87b05.jpg";